import { SelectItem } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { Form } from '@angular/forms';
import { RegistrationUpsert } from '../../shared/registration/crud/registration-upsert.model';
import { RegistrationRegister } from '../../shared/registration/registration-register.model';
import { RegistrationItem } from '../../shared/registration/registration-item.model';
import { RegistrationAttendeeItem } from '../../shared/registration/registration-attendee-item.model';
import { EventRead } from '../../shared/event-read.model';
import { ActivatedRoute } from '@angular/router';
import { WlxTabsComponent } from '../../../shared/widgets/tabs/tabs.component';
import { WlxTabComponent } from '../../../shared/widgets/tabs/tab.component';
import { UtilService, DialogService, NotificationService, TranslationService } from '../../../shared/index';
import { EventV4RegistrationWizardAttendeesComponent } from './event-v4-attendees/event-v4-registration-wizard-attendees.component';
import { EventV4RegistrationWizardItemsComponent } from './event-v4-items/event-v4-registration-wizard-items.component';
import { EventV4RegistrationWizardContactComponent } from './event-v4-contact/event-v4-registration-wizard-contact.component';
import { IValidationComponent } from '../../../shared/widgets/component/ivalidation.component';
import { ValidationResult } from '../../../shared/widgets/validators/validation-result.model';
import { NavigationService } from '../../../shared/navigation/navigation.service';
import { ProfileMin } from '../../../profiles/shared/profile-min.model';
import { ProfileService } from '../../../profiles/shared/profile.service';
import { UserService } from '../../../users/shared/user.service';
import { Title } from '@angular/platform-browser';
import { EventsV4Service } from '../../shared/events-v4.service';
import { EventV4RegistrationService } from '../../shared/registration/event-v4-registration.service';
import { EventV4RegistrationWizardPaymentInfoComponent } from './event-v4-payment-info/event-v4-registration-wizard-payment-info.component';
import { Eventv4RegistrationWizardSponsorComponent } from './event-v4-sponsor/event-v4-registration-wizard-sponsor.component';
import { EventRegistrationActionTrackerService } from '../../shared/event-registration-action-tracker.service';
import { EventRegistrationEditActionDto } from '../../shared/dto/event-registration-edit-action.dto';
import { EventRegistationActionTypeEnum } from '../../shared/dto/event-registation-action-type.enum';
import { CreateRegistrationResultsDto } from '../../shared/registration/create-registration-result.dto';
import { UpdateRegistrationResultsDto } from '../../shared/registration/update-registration-result.dto';
import { AdjustmentTypeService } from '../../../revenue/shared/adjustment-types/adjustment-type.service';
import { AccountingPackageDto } from '../../../revenue/shared/revenue-items/dto/accounting-package.dto';

@Component({
  selector: 'wl-event-v4-registration-wizard',
  templateUrl: 'event-v4-registration-wizard.component.html',
  styleUrls: ['event-v4-registration-wizard.component.less'],
  providers: [EventsV4Service, EventV4RegistrationService],
  standalone: false,
})
export class EventV4RegistrationWizardComponent implements OnInit, IValidationComponent {
  @ViewChild('registrationForm', { static: false })
  registrationForm: Form;
  @ViewChild('registrationWizardTabsComponent', { static: false })
  tabsComponent: WlxTabsComponent;
  @ViewChild('registrationWizardItemsTab', { static: false })
  tabItems: WlxTabComponent;
  @ViewChild('registrationWizardContactTab', { static: false })
  tabContact: WlxTabComponent;
  @ViewChild('registrationWizardAttendeesTab', { static: false })
  tabAttendees: WlxTabComponent;
  @ViewChild('registrationWizardPaymentTab', { static: false })
  tabPayment: WlxTabComponent;
  @ViewChild('registrationWizardSponsorTab', { static: false })
  tabSponsors: WlxTabComponent;

  @ViewChild('registrationWizardAttendeesComponent', { static: false })
  registrationWizardAttendeesComponent: EventV4RegistrationWizardAttendeesComponent;
  @ViewChild('registrationWizardItemsComponent', { static: false })
  registrationWizardItemsComponent: EventV4RegistrationWizardItemsComponent;
  @ViewChild('registrationWizardContactComponent', { static: false })
  registrationWizardContactComponent: EventV4RegistrationWizardContactComponent;
  @ViewChild('registrationWizardPaymentInfoComponent', { static: false })
  registrationWizardPaymentInfoComponent: EventV4RegistrationWizardPaymentInfoComponent;
  @ViewChild('registrationWizardSponsorComponent', { static: false })
  registrationWizardSponsorComponent: Eventv4RegistrationWizardSponsorComponent;

  public eventId: number = 0;
  public registrationId: number = 0;

  @Output() onRegistrationSaved = new EventEmitter<number>();
  @Output() onRegistrationClose = new EventEmitter<null>();

  public _eventService: EventsV4Service;
  public _route: ActivatedRoute;
  public _navService: NavigationService;
  public _utilService: UtilService;
  public _dialogService: DialogService;
  public _registrationService: EventV4RegistrationService;
  public _notifyService: NotificationService;
  public _translationService: TranslationService;
  public _registrationProfile: ProfileMin = null;
  public saveError: string = '';
  public _attendeesLoaded: boolean = false;
  public _sponsorTabEnabled: boolean = false;
  public _loadingEventForRegistration: boolean = false;
  public _loadingRegistration: boolean = false;
  public showModal = false;
  public event: EventRead;
  public registration: RegistrationUpsert;

  public selectedTab: WlxTabComponent;
  public hasSelectedEventItems: boolean;

  public validationResult: ValidationResult;
  public isSaving: boolean;
  public initialLoadComplete: boolean = false;

  public lineItemAccountingPackageIds: Array<number> = [];
  public paymentAccountingPackageIds: Array<number> = [];
  public invoiceLineItemAccountingPackages: Array<AccountingPackageDto> = [];
  public hasRefundableCcPayment: boolean = false;

  public jumpToProfilesItems: SelectItem[] = [];
  public selectedJumpToProfileId: number;

  public constructor(
    navService: NavigationService,
    eventService: EventsV4Service,
    route: ActivatedRoute,
    utilService: UtilService,
    registrationService: EventV4RegistrationService,
    dialogService: DialogService,
    notifyService: NotificationService,
    translationService: TranslationService,
    public _profileService: ProfileService,
    public _userService: UserService,
    private actionTrackerService: EventRegistrationActionTrackerService,
    private _title: Title,
    private _adjustmentTypeService: AdjustmentTypeService
  ) {
    this._utilService = utilService;
    this._route = route;
    this._navService = navService;
    this._registrationService = registrationService;
    this._dialogService = dialogService;
    this._notifyService = notifyService;
    this._translationService = translationService;

    this.eventId = 0;
    this.registrationId = 0;
    this.event = new EventRead();
    this.registration = new RegistrationUpsert();

    this._eventService = eventService;
    this.selectedTab = this.tabItems;
    this.validationResult = new ValidationResult();
    this.hasSelectedEventItems = false;
    this.isSaving = false;
    this.initialLoadComplete = false;
  }

  ngOnInit() {
    this._route.params.subscribe((params) => {
      if (this._utilService.isNotNullOrUndefined(params['registrationId'])) {
        this.registrationId = Number(params['registrationId']);
      }

      if (this._utilService.isNotNullOrUndefined(params['eventId'])) {
        this.eventId = Number(params['eventId']);

        //directly open wizard
        this._eventService.getEventRead(this.eventId).then((data: EventRead) => {
          this.openRegistrationWizard(data, this.registrationId);
          this._title.setTitle(data.EventName + ' ' + this._title.getTitle());
        });
      }
    });
  }

  /**
   * opens the event registration like normal, but loads the event for you first
   * @param eventId
   * @param registrationId (optional. Required if attendee id given)
   * @param attendeeId (optional)
   */
  public openEventRegistrationForEventId(eventId: number, registrationId: number = 0, attendeeId: number = 0): void {
    // already been here
    if (this._loadingEventForRegistration) return;

    this._loadingEventForRegistration = true;

    // clear
    this.validationResult = new ValidationResult();
    this.validationResult.isValid = true;

    this.OpenOrShowModal();

    setTimeout(() => {
      this._eventService.getEventRead(eventId).then(
        (theEvent: EventRead) => {
          this.openRegistrationWizard(theEvent, registrationId, attendeeId);
          this._loadingEventForRegistration = false;
        },
        (error) => {
          this.validationResult.isValid = false;
          this.validationResult.errors.push(this._utilService.extractErrorMessage(error));
          this._loadingEventForRegistration = false;
        }
      );
    });
  }

  public openRegistrationWizard(event: EventRead, registrationId: number, attendeeId: number = 0) {
    this.actionTrackerService.clearActions();
    this.initialLoadComplete = false;
    this.saveError = '';
    this._attendeesLoaded = false;

    //ensure contact tab is selected
    this.tabContact.selected = true;
    this.tabItems.selected = false;
    this.tabAttendees.selected = false;
    this.tabPayment.selected = false;

    if (this._utilService.isNullOrUndefined(event)) {
      this.event = new EventRead();
    } else {
      this.event = event;
    }

    this.eventId = Number(event.EventId);
    if (this._utilService.isNullOrUndefined(registrationId)) {
      registrationId = 0;
    }
    this.registrationId = Number(registrationId);

    this.registration = new RegistrationUpsert();
    this.registration.EventId = this.eventId;
    this.registration.RegistrationId = this.registrationId;

    if (this.registrationId > 0) {
      this.registration.IsEdit = true;
    } else {
      this.registration.IsEdit = false;
    }

    //load child data after we are sure the event input object has been populated
    this.registrationWizardContactComponent.event = this.event;
    this.registrationWizardItemsComponent.event = this.event;
    this.registrationWizardAttendeesComponent.event = this.event;
    this.registrationWizardPaymentInfoComponent.event = this.event;
    this.registrationWizardPaymentInfoComponent.lineItemAccountingPackageIds = this.lineItemAccountingPackageIds;
    this.registrationWizardPaymentInfoComponent.paymentAccountingPackageIds = this.paymentAccountingPackageIds;
    this.registrationWizardPaymentInfoComponent.hasRefundableCcPayment = this.hasRefundableCcPayment;
    this.registrationWizardSponsorComponent.event = this.event;

    this.OpenOrShowModal();

    // load the registration object
    this._loadingRegistration = true;
    let loadPromise = this._registrationService
      .getRegistrationHeaderMin(this.registrationId)
      .then((data: RegistrationRegister) => {
        this.registration.Registration = data;

        if (data && data.ProfileId) {
          let promises: Array<Promise<any>> = [];
          promises.push(this._profileService.getProfileMin(data.ProfileId).then((profile) => (this._registrationProfile = profile)));

          let relatedProfilesPromise: Promise<boolean> = Promise.resolve(false);

          if (data.ProfileId > 0) {
            promises.push(
              this._profileService.checkIsPrimarilyRelatedToMember(data.ProfileId).then((isRelatedToMember: boolean) => {
                this.registration.Registration.IsRelatedToMember = isRelatedToMember;
              })
            );
          }

          return Promise.all(promises);
        } else this._registrationProfile = null;
      })
      .then(() => (this._loadingRegistration = false));

    const me = this;

    if (me.tabAttendees.enabled && attendeeId > 0) me.tabsComponent.select(this.tabAttendees);

    // lets them know attendees will be loaded even if they aren't being loadded first
    me.registrationWizardAttendeesComponent.setWillBeLoadingNext();

    loadPromise.then(() => {
      //they need to share the share reg object
      this.registrationWizardContactComponent.registration = this.registration;
      this.registrationWizardItemsComponent.registration = this.registration;
      this.registrationWizardAttendeesComponent.registration = this.registration;
      this.registrationWizardPaymentInfoComponent.registration = this.registration;
      this.registrationWizardSponsorComponent.registration = this.registration;

      this.registrationWizardContactComponent.registrationId = this.registrationId;
      this.registrationWizardItemsComponent.registrationId = this.registrationId;
      this.registrationWizardAttendeesComponent.registrationId = this.registrationId;
      this.registrationWizardPaymentInfoComponent.registrationId = this.registrationId;
      this.registrationWizardSponsorComponent.registrationId = this.registrationId;

      this.registrationWizardContactComponent.loadData();

      // have to load event items before attendees, or else all items get preselected for the attendees
      // load attendees whether or not loading of items succeeds or fails
      const loadAttendeesF = () =>
        me.registrationWizardAttendeesComponent.loadData().then(
          () => (me._attendeesLoaded = true),
          () => (me._attendeesLoaded = true)
        );
      this.registrationWizardItemsComponent
        .loadData()
        .then(
          () => loadAttendeesF(),
          () => loadAttendeesF()
        )
        .then(() => {
          if (this.registration.IsEdit) this.registrationItemsChanged();
          this.syncRegistrationProfiles();
        })
        .then(() => {
          this.registrationWizardPaymentInfoComponent.loadData().then(() => {
            this.initialLoadComplete = true;
          });
        });

      this.registrationWizardSponsorComponent.loadData(this._registrationProfile);
    });
  }

  public registrationProfileChanged = (newProfile: ProfileMin): void => {
    this.actionTrackerService.addAction({
      Type: EventRegistationActionTypeEnum.RegistrationProfileChanged,
      OldValue: this._registrationProfile,
      NewValue: newProfile,
    } as EventRegistrationEditActionDto);

    this._registrationProfile = newProfile;

    //update any select item totals in case the selected profiel is a member
    this.registrationWizardItemsComponent.getItemTotals();
    this.registrationWizardSponsorComponent.setImageProfileIdFilter(this.registration.Registration.ProfileId);
    this.registrationWizardPaymentInfoComponent.refreshBenefits();
    this.syncRegistrationProfiles();
  };

  public registrationItemsChanged = (): void => {
    //update any select item totals in case the selected profiel is a member
    this.registrationWizardAttendeesComponent.updateAvailableAttendeeRegistrationItems(!this.registration.IsEdit || this._attendeesLoaded);

    // The payment step is instantiated eagerly and only hidden between wizard steps, so its
    // component instance survives every item change - re-resolve the tokenizing gateway here
    // rather than once at mount, or it goes stale the first time the items change.
    this.registrationWizardPaymentInfoComponent?.refreshResolvedGateway();

    let selectedEventItems = this.registration.Items.filter((item: RegistrationItem) => {
      return item.Quantity > 0;
    });

    let selectedSponsorItems = this.registration.Items.filter((item: RegistrationItem) => {
      return item.IsSponsorShip == true && item.Quantity > 0;
    });

    if (selectedEventItems.length > 0) {
      this.hasSelectedEventItems = true;
    } else {
      this.hasSelectedEventItems = false;
    }

    if (selectedSponsorItems.length > 0) {
      this._sponsorTabEnabled = true;

      this.registrationWizardSponsorComponent.loadData(this._registrationProfile);
    } else {
      this._sponsorTabEnabled = false;
    }

    this.registrationWizardPaymentInfoComponent.refreshBenefits();
    this.syncRegistrationProfiles();
  };

  public wizardCancel = (): void => {
    //this.modal.close().then(() => this.onRegistrationClose.emit());
    this.CloseModal();
  };
  public wizardBack = (): void => {
    this.tabsComponent.selectPreviousTab();
  };
  public wizardNext = (): void => {
    this.tabsComponent.selectNextTab();
  };
  public wizardSave = async (): Promise<void> => {
    // modify model being sent to api, but do not modify view's model
    const registrationClone: RegistrationUpsert = JSON.parse(JSON.stringify(this.registration));

    // set DoNotModifyInvoice to true if registration doesn't require invoice modification (per card 1028470786)
    if (
      !(
        registrationClone.IsEdit &&
        (registrationClone.EditTotalAmountChanged ||
          registrationClone.EditOriginalItemsChanged ||
          registrationClone.EditNewItemsAdded ||
          registrationClone.Registration.AdditionalPaymentAmountForEdit < 0 ||
          registrationClone.Registration.PaymentOptionFeeAmount > 0 ||
          registrationClone.Registration.InvoiceTotalDelta != 0)
      )
    ) {
      registrationClone.ModificationOptions.DoNotModifyInvoice = true;
    }

    registrationClone.Attendees.forEach((x) => x.CustomFieldResponses.forEach((x) => (x.Response = x.Response.toString())));
    registrationClone.Registration.EventCustomRegFieldResponses.forEach((x) => (x.Response = x.Response.toString()));

    //pass only the selected registration items
    registrationClone.Items = registrationClone.Items.filter((item: RegistrationItem) => {
      return item.Quantity > 0;
    });

    //pass only the selected attendee registration items
    for (let attendee of registrationClone.Attendees) {
      if (attendee.CreateProfile == true) {
        attendee.ProfileId = 0;
      }
      attendee.Items = attendee.Items.filter((item: RegistrationAttendeeItem) => {
        return item.Selected == true;
      });
    }

    for (let item of registrationClone.Items) {
      //if any items are sponsor items set the sponsor property
      if (item.IsSponsorShip) {
        item.Sponsor = this.registrationWizardSponsorComponent.sponsor;
      }
    }

    if (registrationClone.Registration.CreateProfile == true) {
      registrationClone.Registration.ProfileId = 0;
    }

    //make sure sub components are valid

    let validResult = this.getValidationResult();

    if (validResult.isValid == false) {
      let errorFinal: string = '';
      for (let error of validResult.errors) {
        errorFinal = error + '.  ';
      }
      return;
    } else {
      if (this.registrationWizardPaymentInfoComponent) {
        try {
          await this.registrationWizardPaymentInfoComponent.prepareForPayment();
          // registrationClone was deep-copied before tokenization; sync the token back in.
          if (registrationClone.Registration.CreditCardPayment) {
            registrationClone.Registration.CreditCardPayment.GatewayTokens =
              this.registration.Registration.CreditCardPayment?.GatewayTokens ?? [];
          }
        } catch (e) {
          this._dialogService.error(e);
          return;
        }
      }

      if (
        registrationClone.IsEdit &&
        !registrationClone.ModificationOptions.DoNotModifyInvoice &&
        registrationClone.ModificationOptions.InvoiceAdjustmentTypeId > 0 &&
        this.lineItemAccountingPackageIds.length > 0
      ) {
        const selectedAdjustmentType = await this._adjustmentTypeService.getAdjustmentType(
          registrationClone.ModificationOptions.InvoiceAdjustmentTypeId
        );
        const hasMismatch = this.lineItemAccountingPackageIds.some((id) => id !== selectedAdjustmentType.AccountingPackageId);
        if (hasMismatch) {
          const warningMessage = this._translationService.getInstant(
            'events.registration.management.delete-registration-accounting-package-mismatch-warning'
          );
          this._dialogService.confirmYesNo(warningMessage, () => {
            const missingDefault = this.invoiceLineItemAccountingPackages.some(
              (pkg) => !pkg.AdjustmentTypeID || pkg.AdjustmentTypeID <= 0
            );
            if (missingDefault) {
              this._notifyService.translateError(
                'events.registration.management.edit-registration-accounting-package-missing-default-adjustment-error'
              );
              return;
            }
            this.executeWizardSave(registrationClone);
          }, null);
          return;
        }
      }

      this.executeWizardSave(registrationClone);
    }
  };

  private executeWizardSave(registrationClone: RegistrationUpsert): void {
    this.isSaving = true;
    this.saveError = '';

    this._userService.getCurrentUser().then((user) => {
      if (user) registrationClone.ChangedBy = user.UserName;
      registrationClone.Actions = this.actionTrackerService.getActions();

      this._registrationService.upsertRegistration(registrationClone).then(
        (registrationResult: CreateRegistrationResultsDto | UpdateRegistrationResultsDto) => {
          if (!registrationClone.IsEdit) {
            const createResult = registrationResult as CreateRegistrationResultsDto;
            if (createResult.PaymentFailed) {
              this._notifyService.error(createResult.ErrorMessage);

              if (!createResult.RegistrationCreated) {
                this.isSaving = false;
                return false;
              }
            }
          } else {
            const updateResult = registrationResult as UpdateRegistrationResultsDto;
            if (updateResult.ErrorMessages.length > 0) {
              updateResult.ErrorMessages.forEach((errorMessage) => {
                this._notifyService.error(errorMessage);
              });
              this.isSaving = false;
              return false;
            }

            if (updateResult.WarningMessages.length > 0) {
              updateResult.WarningMessages.forEach((warningMessage) => {
                this._notifyService.warn(warningMessage);
              });
            }
          }

          const registrationHeaderId = registrationClone.IsEdit
            ? (registrationResult as UpdateRegistrationResultsDto).RegistrationId
            : (registrationResult as CreateRegistrationResultsDto).RegistrationHeaderId;

          let currentUrl = this._utilService.toLowerTrim(this._navService.getCurrentUrl());
          let registrationNewUrl = '/event-v4/' + this.event.EventId.toString() + '/registration/new';
          if (currentUrl == registrationNewUrl) {
            //this was called directly from the registration/new route
            //so load the event details page
            this._navService.navigateToEvent(this.event.EventId);
          }

          this._notifyService.success(this._translationService.getInstantTitlecase('events.registration.wizard.save-success-message'));
          this.onRegistrationSaved.emit(registrationHeaderId);

          //reinitialize registration object
          this.registration = new RegistrationUpsert();
          this.CloseModal();
          this.isSaving = false;
          this.hasSelectedEventItems = false;
        },
        (error) => {
          this.validationResult.isValid = false;
          this.saveError = this._utilService.extractErrorMessage(error);
          this.validationResult.errors.push(this.saveError);
          this.isSaving = false;
        }
      );
    });
  }

  public getValidationResult = (): ValidationResult => {
    let valid = new ValidationResult();
    valid.isValid = true;

    let validationError: string = '';
    if (this.registrationWizardAttendeesComponent.getValidationResult().isValid == false) {
      valid.isValid = false;
      for (let error of this.registrationWizardAttendeesComponent.getValidationResult().errors) {
        valid.errors.push(error);
      }

      this.tabAttendees.valid = false;
    } else {
      this.tabAttendees.valid = true;
    }

    if (this.registrationWizardContactComponent.getValidationResult().isValid == false) {
      valid.isValid = false;
      for (let error of this.registrationWizardContactComponent.getValidationResult().errors) {
        valid.errors.push(error);
      }

      this.tabContact.valid = false;
    } else {
      this.tabContact.valid = true;
    }

    if (this.registrationWizardItemsComponent.getValidationResult().isValid == false) {
      valid.isValid = false;
      for (let error of this.registrationWizardItemsComponent.getValidationResult().errors) {
        valid.errors.push(error);
      }

      this.tabItems.valid = false;
    } else {
      this.tabItems.valid = true;
    }

    if (this.registrationWizardPaymentInfoComponent.getValidationResult().isValid == false) {
      valid.isValid = false;
      for (let error of this.registrationWizardPaymentInfoComponent.getValidationResult().errors) {
        valid.errors.push(error);
      }

      this.tabPayment.valid = false;
    } else {
      this.tabPayment.valid = true;
    }

    if (this.registrationWizardSponsorComponent.getValidationResult().isValid == false) {
      valid.isValid = false;
      for (let error of this.registrationWizardSponsorComponent.getValidationResult().errors) {
        valid.errors.push(error);
      }

      this.tabSponsors.valid = false;
    } else {
      this.tabSponsors.valid = true;
    }

    this.validationResult = valid;

    return valid;
  };

  /**
   * they clicked add attendee
   */
  public handleAttendeeNavAddNewAttendeeClick(): void {
    if (!this.tabAttendees.enabled) return;

    this.tabsComponent.select(this.tabAttendees);
    setTimeout(() => this.registrationWizardAttendeesComponent.addNewAttendee());
  }

  /**
   * they clicked an attendee link
   * @param attendeeIndex
   */
  public handleAttendeeNavAttendeeClick(attendeeIndex: number): void {
    if (!this.tabAttendees.enabled) return;

    this.tabsComponent.select(this.tabAttendees);
    setTimeout(() => this.registrationWizardAttendeesComponent.scrollToAttendee(attendeeIndex));
  }

  private OpenOrShowModal(): void {
    this.tabsComponent.selectFirst();
    this.showModal = true;
  }

  private CloseModal(): void {
    this.showModal = false;
    this.registrationWizardPaymentInfoComponent?.creditCardInputComponent?.clearForm();
    this.onRegistrationClose.emit();
  }

  private syncRegistrationProfiles() {
    this.jumpToProfilesItems = [];
    if (this._registrationProfile?.ProfileId) {
      this.jumpToProfilesItems.push({
        label: this._registrationProfile.ReportName,
        value: this._registrationProfile.ProfileId,
      });
    }
    this.registration?.Attendees?.forEach((attendee) => {
      if (attendee.ProfileId && !this.jumpToProfilesItems.find((x) => x.value === attendee.ProfileId)) {
        this.jumpToProfilesItems.push({ label: `${attendee.FName} ${attendee.LName}`, value: attendee.ProfileId });
      }
    });
  }
}
